module.exports = __webpack_public_path__ + "static/media/story-banner.6334e59f.jpg";